import gql from 'graphql-tag';

export default gql`
mutation createPdfExport($projectId: Int!) {
  exportPDF(object: { project_id: $projectId }) {
    pdf_export_url
  }
}
`;
